import PageBanner from './page-banner';

export default PageBanner;